import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DsButtonModule } from '@bmw-ds/components';

import { useI18n } from '../../../i18n/services/i18n.service';
import { BackButtonProvider } from '../../back-button.provider';

@Component({
  selector: 'cdf-back-button',
  imports: [DsButtonModule],
  template: `
    @if (backButtonProvider.backButton(); as backButton) {
      <ds-button
        class="back-button"
        icon="arrow_left"
        variant="ghost"
        [disabled]="disabled()"
        (click)="backButton.action()"
      >
        {{ backButton.label }}
      </ds-button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackButtonComponent {
  protected readonly i18n = useI18n();
  protected readonly backButtonProvider = inject(BackButtonProvider);

  readonly disabled = input<boolean>(false);
}
